import { useTranslation } from "react-i18next";
import HistorySectionLayout from "../../components/History/HistorySectionLayout";
import PositionHistoryTable from "../../components/History/PositionHistoryTable";
import { usePositionHistory } from "../../hooks/api/history/usePositionHistory";
import { useUrlInstrumentFilter } from "../../hooks/useUrlParamState";
import { AssetResponse } from "../../utils/asset";

interface IPositionHistoryTabProps {
  /** "trading" zeroes outer margins for the bottom-bar embed. */
  mode?: "portfolio" | "trading";
  hideTitle?: boolean;
  hideFilter?: boolean;
  /**
   * Server-side market scope for the "show selected market only" toggle. When
   * set, pins the query to the current market's asset (mirrors Positions/Open
   * Orders). Asset only — no instrument-type constraint, so spot + perp for the
   * asset are both included.
   */
  assetFilter?: AssetResponse;
}

export function PositionHistoryTab({
  mode = "portfolio",
  hideTitle,
  hideFilter,
  assetFilter,
}: IPositionHistoryTabProps = {}) {
  const { t } = useTranslation("app", {
    keyPrefix: "pages.PositionHistoryTab",
  });
  const [filter, setFilter] = useUrlInstrumentFilter(
    "tab",
    mode === "portfolio"
  );
  const data = usePositionHistory({
    instrumentType: filter,
    asset: assetFilter,
  });

  return (
    <HistorySectionLayout
      title={t("position_history", { defaultValue: "Position History" })}
      mode={mode}
      hideTitle={hideTitle}
      filter={filter}
      onSetFilter={hideFilter ? undefined : setFilter}
    >
      {(tableHeight) => (
        <PositionHistoryTable
          items={data.items}
          isLoading={data.isLoading}
          isLoadingMore={data.isLoadingMore}
          hasMore={data.hasMore}
          onLoadMore={data.loadMore}
          height={tableHeight}
        />
      )}
    </HistorySectionLayout>
  );
}
